import { IUserGroupType } from "../../constants/types";
import { GET_USERGROUP_ASSIGNED } from '../../constants/action-types';

export function storeAssignedUserGroup(group: IUserGroupType) {
    return { type: GET_USERGROUP_ASSIGNED, group }
}